<div (click)="slideMenuClicked()">
	<p-slideMenu
		#SlideMenu
		[model]="items"
		[viewportHeight]="contextMenuHeight"
		[menuWidth]="contextMenuWidth">
	</p-slideMenu>
</div>